import { render, staticRenderFns } from "./ReferenceNumberDetail.vue?vue&type=template&id=c77244cc"
import script from "./ReferenceNumberDetail.vue?vue&type=script&lang=js"
export * from "./ReferenceNumberDetail.vue?vue&type=script&lang=js"
import style0 from "./ReferenceNumberDetail.vue?vue&type=style&index=0&id=c77244cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports